import React, { useEffect, useState } from 'react';
import { useData } from '../../../contexts';
import { DownloadButton } from '../../DownloadButton/DownloadButton';
// import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import { Grid } from '@mui/material';
import { MdClose, MdHelpOutline } from 'react-icons/md';
import { InsightsBenchmarkEvolutieTable } from './InsightsBenchmarkEvolutieTable';

import { SelectionPanel } from '../InsightsSynthesisSelectionPanel/SelectionMenuComponents/SelectionPanel';
import { ScatterChartQuadrants } from '../../ScatterChart/ScatterChartQuadrants';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../Tooltip/Tooltip';
import { InfoPanelOther } from '../../InfoPanelCluster/InfoPanelOther';

export const InsightsBenchmarkEvolutie = (props: any) => {
  const {
    data: propsData,
    pathInteractieveTool,
    toggled,
    open,
    setOpen,
    themas,
    indicatorThema,
    gemeenteLijst,
    benchmarkLijst,
    setBenchmarkLijst,
    d_ruimte,
    highlightedRow,
    setHighlightedRow,
    tableHighlightedRow,
    setTableHighlightedRow,
  } = props;
  const {
    selectedGemeente,
    selectedTopic,
    selectedBenchmarks,
    interfaceColor,
    barColors,
    locale,
    isZoomedInsights,
    setIsZoomedInsights,
    zoomFilters,
    setZoomFilters,
    deltaColors,
    selectedIndicatorsInzichten,
  } = useData();

  const id = 'Evolutie/Benchmarking';

  const [selectedPeriod, setSelectedPeriod] = useState(3);
  const [xVar, setXVar] = useState('deltaMin' + selectedPeriod);
  const [yVar, setYVar] = useState('deltaMin' + selectedPeriod + 'Bench');

  const zVar = 'z';

  const [dataTable, setDataTable] = useState(propsData);
  const [resetZoom, setResetZoom] = useState(false);
  const [incomingData, setIncomingData] = useState([]) as any[];
  const [initialState, setInitialState] = useState({
    data: incomingData,
    left: 'dataMin',
    right: 'dataMax',
    refAreaLeft: '',
    refAreaRight: '',
    top: 'dataMax',
    bottom: 'dataMin',
    animation: true,
  }) as any[];

  const handleOpen = () => setOpen(true);

  useEffect(() => {
    toggled && handleOpen();
  }, [toggled]);

  const [zoomGraph, setZoomGraph] = useState(initialState);

  const zoomOut = (pageId) => {
    const newTableData = propsData;

    setIsZoomedInsights(false);

    const unique = [...new Set(newTableData.map((d: any) => d.id))];
    setZoomFilters((prev: any) => ({ ...prev, [pageId]: unique }));
    setResetZoom(true);
    setZoomGraph((prev: any) => ({
      ...prev,
      data: newTableData,
      refAreaLeft: '',
      refAreaRight: '',
      left: 'dataMin-1',
      right: 'dataMax+1',
      top: 'dataMax',
      bottom: 'dataMin',
    }));
  };

  const resetData = () => {
    let tmpData = structuredClone(propsData).sort(
      (a: any, b: any) => b[xVar] - a[xVar],
    );

    tmpData.map((d: any, i: number) => {
      d.displayOrder = i + 1;
      return d;
    });

    setInitialState({
      data: tmpData,
      left: 'dataMin',
      right: 'dataMax',
      refAreaLeft: '',
      refAreaRight: '',
      top: 'dataMax+1',
      bottom: 'dataMin-1',
      animation: true,
    });

    setDataTable(propsData);
    setIncomingData(tmpData);
  };

  useEffect(() => {
    resetData();
    zoomOut(id);
  }, [
    propsData,
    setIncomingData,
    setInitialState,
    selectedIndicatorsInzichten,
  ]);

  const onChangeDropdownHandler = (event: any) => {
    event.preventDefault();
    let period = JSON.parse(event.target.value);
    setSelectedPeriod(period);

    const newXVar = 'deltaMin' + period;
    const newYVar = 'deltaMin' + period + 'Bench';

    const data = structuredClone(incomingData);
    data.sort(function (a: any, b: any) {
      return b[newXVar] - a[newXVar];
    });

    data.map((d: any, i: number) => {
      d.displayOrder = i + 1;
      return d;
    });

    setDataTable(propsData);
    setIncomingData(data);

    setXVar(newXVar);
    setYVar(newYVar);
    zoomOut(id);
  };

  return (
    <Grid container style={{ padding: '16px' }}>
      <Grid item xs={12}>
        <div
          className={'vl-typography'}
          style={{ paddingLeft: '8rem', float: 'left', width: '70%' }}
        >
          <h4 className="page-title">
            Hoe verhouden de evolutie van {selectedGemeente.label} en die van de
            benchmark {selectedBenchmarks[0].label} zich ten opzichte van
            elkaar?
          </h4>
          <p className="page-subtitle">
            Hoeveel hoger of lager scoren {selectedGemeente.label} en de
            benchmark {selectedBenchmarks[0].label} ten opzichte van 3 of 6 jaar
            geleden op de gekozen indicatoren?
          </p>
        </div>
        <div
          className={'vl-typography'}
          style={{
            float: 'right',
            // marginLeft: 'auto',
            marginRight: '36px',
            cursor: 'pointer',
            paddingRight: '8px',
            paddingLeft: '8px',
            backgroundColor: interfaceColor,
            borderRadius: 12,
            position: 'relative',
            top: '18px',
          }}
        >
          <p style={{ marginBottom: 0, color: 'white' }} onClick={handleOpen}>
            Pas je selectie aan
          </p>
          <SelectionPanel
            open={open}
            setOpen={setOpen}
            themas={themas}
            indicatorThema={indicatorThema}
            gemeenteLijst={gemeenteLijst}
            selectedGemeente={selectedGemeente}
            selectedBenchmarks={selectedBenchmarks}
            benchmarkLijst={benchmarkLijst}
            setBenchmarkLijst={setBenchmarkLijst}
            d_ruimte={d_ruimte}
          />
        </div>
        <div>
          <InfoPanelOther
            content={
              <>
                <p>
                  Voor elke indicator nemen we voor zowel de gemeente als de
                  benchmark de meest recente meetwaarde en de meetwaarde van 3
                  jaar en 6 jaar eerder. Vervolgens berekenen we voor zowel de
                  gemeente als de benchmark de relatieve toename of afname over
                  deze periode van 3 of 6 jaar. De berekeningen zijn analoog aan
                  deze voor de vorige figuur:
                </p>

                <ul style={{ paddingLeft: 16 }}>
                  <li>
                    <span style={{ color: 'blue' }}>
                      • (meest recente meetwaarde - meetwaarde 3 jaar eerder) /
                      meetwaarde 3 jaar eerder
                    </span>
                  </li>
                  <li>
                    <span style={{ color: 'blue' }}>
                      • (meest recente meetwaarde - meetwaarde 6 jaar eerder) /
                      meetwaarde 6 jaar eerder
                    </span>
                  </li>
                </ul>
                <br />
                <p>
                  Deze figuur toont voor elke indicator hoeveel hoger of lager
                  de meest recente meetwaarde is in vergelijking met 3 jaar of 6
                  jaar eerder, relatief uitgedrukt (als percentage), en dit
                  zowel voor {selectedGemeente.label} (horizontale as) als voor
                  de benchmark {selectedBenchmarks[0].label} (verticale as). Op
                  die manier kan je voor verschillende indicatoren vlot nagaan
                  hoe zowel {selectedGemeente.label} als de benchmark{' '}
                  {selectedBenchmarks[0].label} evolueren ten opzichte van 3
                  jaar of 6 jaar geleden, en hoe deze evoluties zich ten
                  opzichte van elkaar verhouden.
                </p>
                <br />
                <p>Hoe deze figuur interpreteren?</p>

                <ul style={{ paddingLeft: 16 }}>
                  <li>
                    • Bevindt een indicator zich in het kwadrant rechtsboven,
                    dan worden zowel {selectedGemeente.label} als de benchmark
                    {selectedBenchmarks[0].label} gekenmerkt door een relatieve
                    toename ten opzichte van 3 of 6 jaar eerder.
                  </li>
                  <li>
                    • Bevindt een indicator zich in het kwadrant linksonder, dan
                    worden zowel {selectedGemeente.label} als de benchmark{' '}
                    {selectedBenchmarks[0].label} gekenmerkt door een relatieve
                    afname ten opzichte van 3 of 6 jaar eerder.
                  </li>
                  <li>
                    • Bevindt een indicator zich in het kwadrant linksboven, dan
                    wordt {selectedGemeente.label} gekenmerkt door een relatieve
                    afname en de benchmark {selectedBenchmarks[0].label} door
                    een relatieve toename ten opzichte van 3 of 6 jaar eerder.
                  </li>
                  <li>
                    • Bevindt een indicator zich in het kwadrant rechtsonder,
                    dan wordt {selectedGemeente.label} gekenmerkt door een
                    relatieve toename en de benchmark{' '}
                    {selectedBenchmarks[0].label} door een relatieve afname ten
                    opzichte van 3 of 6 jaar eerder.
                  </li>
                  <li>
                    • Bevindt een indicator zich op de diagonaal (in
                    stippellijn), dan is de relatieve toe- of afname van{' '}
                    {selectedGemeente.label}
                    en van de benchmark {selectedBenchmarks[0].label} gelijk.
                  </li>
                </ul>
                <br />
                <p>Aandachtspunten:</p>

                <ul style={{ paddingLeft: 16 }}>
                  <li>
                    • Voor sommige indicatoren zijn er geen data beschikbaar
                    voor 3 jaar of 6 jaar eerder. Voor deze indicatoren kunnen
                    we bijgevolg geen relatieve toename of afname berekenen. Dit
                    staat ook zo aangegeven in de tabel, en deze indicatoren
                    zijn ook niet zichtbaar in de figuur.
                  </li>
                </ul>
                <br />
                <p>
                  Wil je inzoomen op een aantal bolletjes/indicatoren binnen de
                  figuur? Selecteer de gewenste bolletjes/indicatoren. Deze
                  selectie van indicatoren wordt vervolgens ook doorgetrokken
                  naar de andere figuren op de pagina.
                </p>
                <br />
                <p>
                  Wil je de tabel anders sorteren? Je kan de tabel sorteren op
                  elk van de kolommen. Standaard is de tabel gesorteerd op de
                  kolom ‘Gemeente relatieve toe-/afname’.
                </p>
              </>
            }
          />
        </div>
      </Grid>

      <Grid
        item
        xs={12}
        pl={5}
        pr={5}
        height={'85vh'}
        minHeight={'400px'}
        maxHeight={'85vh'}
        id={id}
        sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}
      >
        {incomingData !== undefined && incomingData.length > 0 ? (
          <Grid container sx={{ maxHeight: '100%' }}>
            <Grid
              item
              xs={12}
              sx={{ paddingLeft: '36px', paddingRight: '32px' }}
            >
              <div className="vl-form-col--12-12" style={{ padding: '0.6rem' }}>
                <select
                  name="evolutieSelect"
                  className="vl-select vl-select--block"
                  tabIndex={0}
                  data-vl-select=""
                  data-vl-select-search-empty-text="Geen resultaten gevonden"
                  onChange={onChangeDropdownHandler}
                >
                  <option key={0} value={3} selected={selectedPeriod === 3}>
                    Meest recente meetwaarde versus 3 jaar eerder
                  </option>
                  <option key={1} value={6} selected={selectedPeriod === 6}>
                    Meest recente meetwaarde versus 6 jaar eerder
                  </option>
                </select>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                height: '30px',
                maxHeight: '30px',
                paddingRight: '36px',
                paddingLeft: '100px',
              }}
            >
              <div
                style={{
                  whiteSpace: 'break-spaces',
                  fontSize: '13px',
                  paddingRight: '16px',
                  paddingTop: '16px',
                }}
              >
                <ul>
                  {Object.keys(zoomFilters).map((d: any) => {
                    if (
                      zoomFilters[d].length !== 0 &&
                      zoomFilters[d].length !== incomingData.length
                    ) {
                      return (
                        <li
                          onClick={() => zoomOut(d)}
                          style={{
                            display: 'inline-block',
                            margin: 4,
                            marginTop: 8,
                            paddingLeft: 8,
                            paddingRight: 14,
                            backgroundColor: interfaceColor,
                            borderRadius: 24,
                            color: 'white',
                            cursor: 'pointer',
                            position: 'relative',
                            top: '-14px',
                          }}
                        >
                          Filter: {d}
                          <span
                            style={{
                              fontWeight: 'bold',
                              position: 'relative',
                              top: 3,
                              left: 8,
                            }}
                          >
                            <MdClose />
                          </span>
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
            </Grid>

            <Grid
              item
              xs={5}
              sx={{
                height: '68vh',
                maxHeight: '68vh',
                paddingLeft: '36px',
                paddingRight: '36px',
                userSelect: 'none',
                fontSize: '0.8em',
              }}
            >
              <ScatterChartQuadrants
                pageId={id}
                xAxisDataKey={xVar}
                yAxisDataKey={yVar}
                zAxisDataKey={zVar}
                incomingData={incomingData}
                zoomFilters={zoomFilters}
                resetZoom={resetZoom}
                setResetZoom={setResetZoom}
                setDataTable={setDataTable}
                setZoomFilters={setZoomFilters}
                setIsZoomedInsights={setIsZoomedInsights}
                zoomGraph={zoomGraph}
                setZoomGraph={setZoomGraph}
                locale={locale}
                highlightedRow={highlightedRow}
                setHighlightedRow={setHighlightedRow}
                selectedPeriod={selectedPeriod}
                tableHighlightedRow={tableHighlightedRow}
                setTableHighlightedRow={setTableHighlightedRow}
              />
            </Grid>

            <Grid
              item
              xs={7}
              sx={{
                height: '68vh',
                maxHeight: '68vh',
                paddingRight: '36px',
                paddingLeft: '60px',
              }}
            >
              <InsightsBenchmarkEvolutieTable
                data={dataTable}
                pathInteractieveTool={pathInteractieveTool}
                setHighlightedRow={setHighlightedRow}
                period={selectedPeriod}
                tableHighlightedRow={tableHighlightedRow}
                setTableHighlightedRow={setTableHighlightedRow}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container style={{ padding: '16px' }}>
            <Grid
              item
              xs={12}
              pl={5}
              pr={5}
              height={'60vh'}
              minHeight={'400px'}
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              {' '}
              <p>Geen data gevonden</p>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
